import { render, staticRenderFns } from "./cModalPaymentMethod.vue?vue&type=template&id=54cd7532&scoped=true"
import script from "./cModalPaymentMethod.vue?vue&type=script&lang=js"
export * from "./cModalPaymentMethod.vue?vue&type=script&lang=js"
import style0 from "./cModalPaymentMethod.vue?vue&type=style&index=0&id=54cd7532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cd7532",
  null
  
)

export default component.exports